import { withInstall } from '@mts-fe/utils';
// import _Pivot from './src/Pivot.vue';
import _PivotModal from './src/PivotModal.vue';

// export const Pivot = withInstall(_Pivot);
export const PivotModal = withInstall(_PivotModal);
